var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: (_vm.dialogStatus === "create" ? "新增" : "编辑") + "流水段"
      },
      on: {
        close: _vm.dialogClose,
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "editFlowForm",
          attrs: {
            model: _vm.editFlowForm,
            rules: _vm.formRules,
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "section_name", label: "流水段名称" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入流水段名称" },
                        model: {
                          value: _vm.editFlowForm.section_name,
                          callback: function($$v) {
                            _vm.$set(_vm.editFlowForm, "section_name", $$v)
                          },
                          expression: "editFlowForm.section_name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "pipeline_start", label: "开始流水" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入开始流水" },
                        model: {
                          value: _vm.editFlowForm.pipeline_start,
                          callback: function($$v) {
                            _vm.$set(_vm.editFlowForm, "pipeline_start", $$v)
                          },
                          expression: "editFlowForm.pipeline_start"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8, offset: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "pipeline_end", label: "截止流水" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入截止流水" },
                        model: {
                          value: _vm.editFlowForm.pipeline_end,
                          callback: function($$v) {
                            _vm.$set(_vm.editFlowForm, "pipeline_end", $$v)
                          },
                          expression: "editFlowForm.pipeline_end"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "12px" },
              on: { click: _vm.dialogClose }
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.editFlowSection } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ad0538c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad0538c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SettingManage/components/EditFlowSectionDIalog.vue
// module id = null
// module chunks = 